import type React from "react";
import {memo, useMemo} from "react";

import {nearbyAmenitiesOptions} from "../constant";
import type {NearbyAmenityType} from "../type";

import {TableCell, TableRow} from "@/client/components/Table";
import TableCellEditRemoveActions from "@/client/components/Table/TableCellEditRemoveActions";
import {convertOptionsToMap} from "@/client/utils/convertOptionsToMap";

type Props = {
    item: NearbyAmenityType;
    index: number;
    onRemove: (index: number) => void;
    onEdit?: (item: NearbyAmenityType, index?: number) => void;
};

const Item: React.FC<Props> = ({item, index, onRemove, onEdit}) => {
    const optionsMap = useMemo(() => convertOptionsToMap(nearbyAmenitiesOptions), []);

    return (
        <TableRow>
            <TableCell>{optionsMap[item.attributeId]}</TableCell>
            <TableCell>{item.distance}</TableCell>
            <TableCell align="end">
                <TableCellEditRemoveActions
                    id={index}
                    item={item}
                    onEdit={onEdit}
                    onRemove={onRemove}
                />
            </TableCell>
        </TableRow>
    );
};

export default memo(Item);
